<template>
  <modal v-bind="[$props, $attrs]"
         class="info-modal"
         @modal-close="emitCloseEvent">
    <template #body>
      <img v-if="$props.infoIcon" :src="$props.infoIcon" alt="info-icon">
      <span v-if="$props.infoTitle" class="info-modal-title">{{ $props.infoTitle }}</span>
      <span v-if="$props.dynamicTitle" class="info-modal-title" v-html="$props.dynamicTitle"/>
      <span v-if="$props.description" class="info-modal-description">{{ $props.description }}</span>
      <span v-if="$props.dynamicDescription" class="info-modal-description" v-html="$props.dynamicDescription"/>
      <base-button v-if="$props.ctaText" @click="click">{{ $props.ctaText }}</base-button>
      <div v-if="$props.url" class="info-modal-url">
        <a :href="$props.url">{{ $props.urlText }}</a>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/common/modal/modal'
import BaseButton from '@/components/base/base-button'

export default {
  name: 'info-modal',
  components: { Modal, BaseButton },
  inheritAttrs: false,
  props: {
    infoIcon: String,
    infoTitle: String,
    dynamicTitle: String,
    description: String,
    dynamicDescription: String,
    ctaText: String,
    url: String,
    urlText: String,
    redirect: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click () {
      this.$emit('click')
    },
    emitCloseEvent () {
      this.$emit('close', this.$props.redirect)
    }
  }
}
</script>

<style lang="scss" scoped>
.info-modal {
  /deep/ .custom-modal__header {
    padding-bottom: 0;

    + .custom-modal__body {
      padding-top: 0;
    }
  }

  /deep/ .custom-modal__body {
    padding: .8rem 0;
    text-align: center;

    @media (map_get($breakpoints, sm)) {
      padding: 3.2rem 0;
    }
  }
}

.info-modal-title {
  display: block;
  margin: 2.4rem 0 1.6rem;
  color: $text;
  font-size: 2rem;

  @media (map_get($breakpoints, sm)) {
    font-size: 2.4rem;
  }
}

.info-modal-description {
  display: block;
  color: $dark-grey;

  /deep/ a {
    font-weight: 600;
  }
}

.base-button {
  margin-top: 4rem;
  min-width: 24rem;

  + .info-modal-url {
    margin-top: 1.6rem;

    @media (map_get($breakpoints, sm)) {
      display: inline-block;
      margin-top: 0;
      margin-left: 2.4rem;
    }
  }
}

.info-modal-url {
  margin-top: 2.4rem;
}
</style>
